import { render, staticRenderFns } from "./DownlineRepDetail.vue?vue&type=template&id=2223a11a&"
import script from "./DownlineRepDetail.vue?vue&type=script&lang=js&"
export * from "./DownlineRepDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/downline-reps.css?vue&type=style&index=0&lang=css&"
import style1 from "./DownlineRepDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports